// Angular
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ISectorAir } from 'libraries/service/resources/booking/interfaces/IGetBookings';

//
import { faInfoCircle, faPlane, IconDefinition } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'table-sector-air-summary',
    template: `
        <div class="sectors-container">
            <fa-icon [icon]="iconPlane" class="icon-plane"></fa-icon>
            <div class="sectors-list">
                <sectors-air-simple-list
                    class="main-informations"
                    [sectors]="sectors"></sectors-air-simple-list>
                <fa-icon [icon]="iconInfoCircle" class="icon-info" (click)="openDetails()"></fa-icon>
            </div>

            <ng-content></ng-content>
        </div>


        <sectors-air-summary-with-rupture *ngIf="sectorsDetailsShown"
            [sectors]="sectors"></sectors-air-summary-with-rupture>
    `,
    styles: [`
        .sectors-container {
            display: flex;
            align-items: baseline;
            margin-bottom: .75rem;
            font-weight: bold;
        }

        .icon-plane {
            margin-right: .75rem;
        }

        .sectors-list {
            display: flex;
            align-items: baseline;
            justify-content: space-between;
        }

        .icon-info {
            color: #337ab7;
            cursor: pointer;
        }

        .main-informations {
            min-width: 80%;
            margin-right: .75rem;
        }
    `]
})
export class TableSectorAirSummaryComponent {
    @Input()
    public sectors: ISectorAir[];

    @Output()
    public readonly onOpenDetails: EventEmitter<boolean> = new EventEmitter();

    public sectorsDetailsShown: boolean = false;

    public iconPlane: IconDefinition = faPlane;
    public iconInfoCircle: IconDefinition = faInfoCircle;

    public openDetails(): void {
        this.sectorsDetailsShown = !this.sectorsDetailsShown;
        this.onOpenDetails.emit(this.sectorsDetailsShown);
    }
}